export default "__VITE_ASSET__9a29f042__"